import styles from './NewsList.scss';
import Link from 'next/link';
import { useState } from 'react';
import { pagesPath } from '@/lib/$path';
import { LoadedView } from '@/components/atoms/loading/LoadedView';
import { GlobalLayout } from '../layout/GlobalLayout';
import { dayjs } from '@/lib/dayjs';
import ReactPaginate from 'react-paginate';
import { useNewsList } from '@/hooks/news/newsHooks';

const itemsPerPage = 10;

export const NewsList: React.FC = () => {
  const [itemOffset, setItemOffset] = useState(0);
  const { data } = useNewsList({ limit: itemsPerPage, offset: itemOffset });

  const list = data?.contents;
  const totalCount = data?.totalCount || 0;
  const pageCount = Math.ceil(totalCount / itemsPerPage);

  const handlePageClick = (event: { selected: number }) => {
    setItemOffset((event.selected * itemsPerPage) % totalCount);
  };

  return (
    <GlobalLayout>
      <main className="news-list-layout">
        <h1 className="list-title">お知らせ</h1>
        <LoadedView loading={!list}>
          {list && list.length ? (
            <ul>
              {list.map((item) => {
                return (
                  <li key={item.id} className="news-item">
                    <Link href={pagesPath.news._newsId(item.id).$url()}>
                      <a>
                        <p>{dayjs(item.publishAt).format('YYYY年M月D日')}</p>
                        <p>{item.title}</p>
                      </a>
                    </Link>
                  </li>
                );
              })}
            </ul>
          ) : (
            <div>お知らせはありません</div>
          )}
        </LoadedView>
        {!!pageCount && pageCount > 1 && (
          <ReactPaginate
            breakLabel="..."
            nextLabel=">"
            onPageChange={handlePageClick}
            pageRangeDisplayed={5}
            pageCount={pageCount}
            previousLabel="<"
            containerClassName="pagination"
          />
        )}
      </main>
      <style jsx>{styles}</style>
    </GlobalLayout>
  );
};
